/**
 *
 * @module graphQlQuery
 *
 */

import Check from 'check-types';
import Services from './../services/entry';

const GraphQlBuilder = Services.Content.GraphQlBuilder;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    instanceStrict,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class ContentQuery
 * @desc Represents a Content query with context and a GraphQlQuery.
 *
 */
export default class ContentQuery {

    /**
     *
     * @param {String} context
     * @param {GraphQlBuilder} graphQl
     *
     */
    constructor(context, graphQl) {

        const errorMessage = {
            ctor: 'ContentQuery(context, graphQl)',
            get context() {
                return `${this.ctor} needs context String with length`;
            },
            get graphQlBuilder() {
                return `${this.ctor} needs GraphQlBuilder instance`;
            }
        };

        nonEmptyString(context, errorMessage.context, InvalidArgumentException);
        instanceStrict(graphQl, GraphQlBuilder, errorMessage.graphQlBuilder, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.context = context;

        /**
         *
         * @access public
         * @type {GraphQlBuilder}
         *
         */
        this.graphQl = graphQl;

    }

}



// WEBPACK FOOTER //
// ./src/content/contentQuery.js